import {assertAndContinue} from 'Asserts';
import {RoutineExecutionKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {assertNever} from 'util/Types';

import {TriggerType} from './RoutineTypes';

export function getTriggerLabel(triggerType: TriggerType): string {
  return triggerType === TriggerType.EVENT_BASED ? 'Event based' : 'Time based';
}

export function getRunKindLabel(
  executionKind: RoutineExecutionKind | null | undefined,
  triggerType: TriggerType
): string {
  switch (executionKind) {
    case RoutineExecutionKind.SCHEDULED:
      return 'Time-based trigger';
    case RoutineExecutionKind.EVENT:
      return 'Event-based trigger';
    case RoutineExecutionKind.MANUAL_RUN:
      return 'Run now';
    case RoutineExecutionKind.USER_MESSAGE:
      return 'Direct message';
    case RoutineExecutionKind.AGENT_MESSAGE:
      return 'Agent message';
    case null:
    case undefined:
      return getTriggerLabel(triggerType);
    default:
      assertAndContinue(false, `Unexpected routine execution kind: ${assertNever(executionKind)}`);
      return getTriggerLabel(triggerType);
  }
}
